import { makeStyles } from '@material-ui/core';
import * as colours from 'colours';

export const useFooterCopyrightStyles = makeStyles((theme) => ({
  text: {
    color: colours.FOOTER_TEXT_PRIMARY,
    fontSize: '10px',
    lineHeight: '14px',
  },
  box: {
    width: '100%',
    padding: '10px 0',
    textAlign: 'center',
    backgroundColor: colours.WHITE,
  },
}));
